module.exports = __webpack_public_path__ + "img/label-2DUPLO.41ad9a92.jpeg";